<template>
    <div class="container">
        <el-date-picker
                size="mini"
                :clearable="false"
                v-model="dateRange"
                type="daterange"
                value-type="timestamp"
                placeholder="选择日期">
        </el-date-picker>
    </div>
</template>
<script>
  import moment from "moment";
  export default {
    name: '',
    components: {},
    props: {
      value: {
        type: Array,
        default() {
          return [moment().startOf("month").toDate(), new Date()]
        }
      }
    },

    data() {
      return {
        dateRange: this.value
      }
    },
    mounted() {
      this.$emit('change', this.dateRangeTs)
    },
    methods: {},
    computed: {
      dateRangeTs() {
        let [start_time, end_time] = this.dateRange
        start_time = moment(start_time).startOf('day').unix()
        end_time = moment(end_time).endOf('day').unix()
        return {
          start_time,
          end_time
        }
      }
    },
    watch: {
        dateRangeTs () {
          this.$emit('change', this.dateRangeTs)
        }
    }
  }
</script>
<style lang="scss" scoped>
    .container {
        display: inline-block;
        margin: 5px 0 ;
    }
</style>
